(function(){
  function init(root){
    if(root.dataset.finderReady==='1') return;
    root.dataset.finderReady='1';
    var dialog=root.querySelector('.mp-finder-dialog');
    var form=root.querySelector('.mp-finder-form');
    var steps=Array.from(root.querySelectorAll('[data-finder-step]'));
    var progress=root.querySelector('[data-finder-progress]');
    var fill=root.querySelector('[data-finder-progress-fill]');
    var error=root.querySelector('[data-finder-error]');
    var results=root.querySelector('[data-finder-results]');
    var grid=root.querySelector('[data-finder-result-grid]');
    var note=root.querySelector('[data-finder-results-note]');
    var back=root.querySelector('[data-finder-back]');
    var next=root.querySelector('[data-finder-next]');
    var launch=root.querySelector('[data-finder-open]');
    var index=0;
    root.querySelectorAll('input[name="audience"]').forEach(function(input){
      if(!root.querySelector('.mp-finder-candidate[data-audience="'+input.value+'"]')){
        input.disabled=true;
        input.nextElementSibling.textContent+=' — indisponible actuellement';
      }
    });
    function showStep(){
      steps.forEach(function(step,i){step.hidden=i!==index});
      results.hidden=true;form.hidden=false;error.hidden=true;
      progress.textContent='Question '+(index+1)+' sur '+steps.length;
      fill.style.width=((index+1)/steps.length*100)+'%';
      back.hidden=index===0;
      next.firstChild.textContent=index===steps.length-1?'Voir ma sélection ':'Continuer ';
      steps[index].querySelector('legend').setAttribute('tabindex','-1');
      steps[index].querySelector('legend').focus();
    }
    function norm(value){return (value||'').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'')}
    function score(card,answers){
      var title=norm(card.dataset.title),value=0;
      var has=function(re){return re.test(title)};
      if(answers.matiere==='cuir') value+=has(/cuir/)?7:(has(/daim|nubuck/)?-7:-2);
      if(answers.matiere==='daim') value+=has(/daim|nubuck/)?7:(has(/cuir/)?-7:-2);
      if(answers.finition==='verni') value+=has(/verni|brillant/)?7:-4;
      if(answers.finition==='mat') value+=has(/mat|daim|nubuck/)?7:-4;
      if(answers.ligne==='marquee') value+=has(/plateforme|semelle epaisse/)?13:(has(/compense|talon/)?2:-3);
      if(answers.ligne==='classique') value+=has(/plateforme|semelle epaisse/)?-6:(has(/compense|talon/)?-2:4);
      if(answers.occasions.includes('bureau')) value+=has(/classique|habille|costume|cuir|noir/)?2:0;
      if(answers.occasions.includes('occasion')) value+=has(/verni|brillant|chaine|gland|talon|habille/)?2:0;
      if((answers.occasions.includes('bureau')||answers.occasions.includes('occasion'))&&has(/chausson|mule|pantoufle/)) value-=12;
      if(answers.occasions.includes('quotidien')) value+=has(/souple|mat|daim|respirant/)?2:0;
      if(answers.priorites.includes('sobre')) value+=has(/mat|classique|noir|marron|beige/)?2:0;
      if(answers.priorites.includes('caractere')) value+=has(/chain|gland|boucle|plateforme|verni|brillant/)?3:0;
      if(answers.priorites.includes('facile')) value+=has(/noir|marron|beige|blanc/)?2:0;
      if(answers.priorites.includes('souple')) value+=has(/souple/)?5:0;
      return value;
    }
    function showResults(){
      var data=new FormData(form);
      var answers={audience:data.get('audience'),occasions:data.getAll('occasion'),matiere:data.get('matiere'),finition:data.get('finition'),ligne:data.get('ligne'),priorites:data.getAll('priorite')};
      var candidates=Array.from(root.querySelectorAll('.mp-finder-candidate')).filter(function(card){
        return card.dataset.audience===answers.audience;
      });
      function ranked(list){return list.slice().sort(function(a,b){
        if(answers.audience==='femme'&&answers.ligne==='marquee'){
          var isPlatform=function(card){return /plateforme|semelle epaisse/.test(norm(card.dataset.title))};
          var platformDifference=Number(isPlatform(b))-Number(isPlatform(a));
          if(platformDifference) return platformDifference;
        }
        var difference=score(b,answers)-score(a,answers);
        if(difference) return difference;
        return (Number(a.dataset.rank)||999)-(Number(b.dataset.rank)||999);
      })}
      var unique=new Map();
      candidates.forEach(function(card){if(!unique.has(card.dataset.handle)) unique.set(card.dataset.handle,card)});
      var selected=ranked(Array.from(unique.values()));
      grid.replaceChildren();
      selected.forEach(function(card){grid.append(card.cloneNode(true))});
      results.querySelector('h3').textContent=selected.length+(selected.length===1?' modèle à découvrir':' modèles à découvrir');
      note.textContent=selected.length?'Les modèles les plus proches de vos choix apparaissent en premier. Continuez à parcourir la sélection pour découvrir d’autres paires qui pourraient vous plaire.':'Aucun modèle disponible dans cette collection pour le moment. Parcourez nos autres collections.';
      form.hidden=true;results.hidden=false;progress.textContent='Votre sélection';fill.style.width='100%';
      results.querySelector('h3').setAttribute('tabindex','-1');results.querySelector('h3').focus();
    }
    launch.addEventListener('click',function(){index=0;form.reset();dialog.showModal();showStep()});
    root.querySelector('[data-finder-close]').addEventListener('click',function(){dialog.close()});
    dialog.addEventListener('click',function(event){if(event.target===dialog) dialog.close()});
    dialog.addEventListener('close',function(){launch.focus()});
    back.addEventListener('click',function(){if(index>0){index--;showStep()}});
    next.addEventListener('click',function(){
      var selected=steps[index].querySelector('input:checked');
      if(!selected){error.hidden=false;steps[index].querySelector('input').focus();return}
      if(index===steps.length-1){showResults();return}
      index++;showStep();
    });
    form.addEventListener('change',function(){error.hidden=true});
    root.querySelector('[data-finder-restart]').addEventListener('click',function(){index=0;form.reset();showStep()});
  }
  function initAll(container){(container||document).querySelectorAll('[data-mp-finder]').forEach(init)}
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){initAll(document)});else initAll(document);
  document.addEventListener('shopify:section:load',function(event){initAll(event.target)});
})();
